exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedor{\r\n  padding-left: 10%;\r\n  padding-right: 10%;\r\n  padding-top: 2%;\r\n  height: 100%;\r\n}\r\n\r\nagm-map {\r\n  width: 100%;\r\n  height:400px;\r\n}\r\n\r\n.btn-primary{\r\n  background-color: #f27b24 !important;\r\n  border-color: #f27b24 !important;\r\n}\r\n\r\n#volver{\r\n  padding-left: 25%;\r\n}\r\n\r\na{\r\n  color: #fa6525;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/new-post/new-post.component.css
// module id = ../../../../../src/app/new-post/new-post.component.css
// module chunks = main